export const FALLBACK_THUMBNAIL_URL =
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='640' height='360' viewBox='0 0 640 360'%3E%3Cdefs%3E%3ClinearGradient id='g' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0' stop-color='%23252a54'/%3E%3Cstop offset='1' stop-color='%23161b38'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='640' height='360' fill='url(%23g)'/%3E%3Ccircle cx='320' cy='180' r='54' fill='%23ffcc5c' fill-opacity='.95'/%3E%3Cpath d='M306 148v64l56-32z' fill='%23161b38'/%3E%3C/svg%3E";

export function applyFallbackThumbnail(image: HTMLImageElement): void {
    if (image.src !== FALLBACK_THUMBNAIL_URL) {
        image.src = FALLBACK_THUMBNAIL_URL;
    }
}
